import { actionEsOnMessage } from '@skynet/data-ws-es';
import { actionOnMessage } from '@skynet/data-ws-mm';
import { createServerModeSlice } from './factory';
import { ServerPrefixes } from './types';

const mmServerModeSlice = createServerModeSlice(ServerPrefixes.MM, actionOnMessage);
const esServerModeSlice = createServerModeSlice(ServerPrefixes.ES, actionEsOnMessage);

export const mmServerModeActions = mmServerModeSlice.actions;
export const mmServerModeReducer = mmServerModeSlice.reducer;

export const esServerModeActions = esServerModeSlice.actions;
export const esServerModeReducer = esServerModeSlice.reducer;

/** Any action of the MM or ES server-mode slice. */
export type ServerModeAction =
  | ReturnType<(typeof mmServerModeActions)[keyof typeof mmServerModeActions]>
  | ReturnType<(typeof esServerModeActions)[keyof typeof esServerModeActions]>;
